module.exports = __webpack_public_path__ + "static/media/flood_3.07868b01.png";